import { render, staticRenderFns } from "./statisticsSec.vue?vue&type=template&id=55bedb3a&scoped=true&"
import script from "./statisticsSec.vue?vue&type=script&lang=js&"
export * from "./statisticsSec.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSec.vue?vue&type=style&index=0&id=55bedb3a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bedb3a",
  null
  
)

export default component.exports